 
                        <nb-card *ngIf="playlist" [nbSpinner]="loading" class="own-scroll">
                            <nb-card-header>
				<div style="display:flex">
                              <div  style="display:flex;   cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">Купівля плейлиста</div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">
	
				   <nb-toggle
					 [disabled]="!authService.currentTariff?.saleAvailable"
				     labelPosition="left"
				      [(checked)]="saleOn" 
				      (checkedChange)="toggleSaleOn()" 
				      status="primary">
				      <span *ngIf="saleOn">Увімкнена</span>
				      <span *ngIf="!saleOn">Вимкнена</span>
				    </nb-toggle>

   </div>
				</div>
                            </nb-card-header>
                            <nb-card-body >
 
		<div>
			<label>Ціна</label>
 			<div style="display:flex;     align-items: center;">

			<div style="display:flex; flex:1">
			<input type="number" class="priceInput" [disabled]="!saleOn" (keyUp.enter)="priceChange()" [(ngModel)]="price"  min="0" nbInput fullWidth />

	 </div>
		<div style="display:flex; margin-left:10px"> грн. </div>
                              
		<div style="display:flex; margin-left:10px"> <button  [disabled]="!saleOn || price === playlist.price || price < 1 || !authService.currentTariff?.saleAvailable" status="primary" (click)="priceChange()"   [disabled]="!authService.currentTariff?.saleAvailable"  nbButton>Зберегти</button> </div>

                              </div>
     </div>
                            </nb-card-body>
                            
                            </nb-card>
 
  


 
